import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { redirect } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { routes, useLoaderData } from "./SignOut.Parts";

export const SignOut = () => {
  const navigate = useNavigate();
  const { signOut: redirectUrl } = useLoaderData();

  useEffect(() => {
    if (redirectUrl) redirect(redirectUrl);
    else navigate(routes.base, { replace: true });
  }, [redirectUrl, navigate]);

  return <LoadingSplash />;
};
